import React, { useState } from 'react';
import { VoicemailList } from '@/components/VoicemailList/VoicemailList';
import { VoicemailItem } from '@/components/VoicemailItem/VoicemailItem';
import { IVoicemail } from '@/shared/interfaces/voicemail.interface';
import emptyIcon from '@/public/icons/empty.svg';
import { IVoicemailsResponse } from '@/services/solgari-api/interfaces/voicemail.interface';
import './index.scss';

interface Props {
  data: IVoicemailsResponse;
}

export function Voicemail({ data }: Props) {
  const [itemChosen, setItemChosen] = useState<null | IVoicemail>(null);
  const [currentList] = useState<any>(data);

  // REMOVE WHEN DONE
  // const [note, setNote] = useState<INoteState>({
  //   id: '',
  //   text: '',
  //   relatedToData: null,
  //   assignToData: null,
  // });
  // const savePhoneCall = async (
  //   desc: string,
  //   relatedInfo: DynRelatedToData,
  //   noteId: string,
  // ): Promise<string> => {
  //   return new Date().toDateString();
  // };

  return currentList?.voicemails?.length ? (
    <div className="voicemail-page">
      {itemChosen ? (
        <VoicemailItem item={itemChosen} setItemChosen={setItemChosen} />
      ) : (
        <VoicemailList
          list={currentList?.voicemails}
          setItemChosen={setItemChosen}
        />
      )}
    </div>
  ) : (
    <div className="empty-box-container">
      <img src={emptyIcon} alt="empty" />
      <div>There are no voicemails.</div>
      {/* <Button onClick={handleChangeMock} style={{ position: 'absolute', bottom: '30px', left: '10px' }}>
                Test mock voicemails
            </Button> */}

      {/* <CallPanel
                note={note}
                // currentNote={currentNote}
                // setCurrentNNote={setCurrentNote}
                setNote={setNote}
                savePhoneCallHandler={savePhoneCall}
                client={{
                    fullName: 'Maryia Herman',
                    id: '9298d10e-80cc-ed11-b597-000d3add08ea',
                    initialPhone: '48507709258',
                    phone: '+48507709258',
                    secondPhone: '+48507709258',
                    type: 'contact',
                }}
            /> */}
    </div>
  );
}
